export * from './currency';
export * from './delivery/IconHelveticor';
export * from './delivery/IconHelveticorSecondary';
export * from './delivery/IconLoomis';
export * from './delivery/IconSwissPost';
export * from './delivery/IconUPS';
export * from './Icon';
export * from './Icon2StepAuth1';
export * from './Icon2StepAuth2';
export * from './Icon2StepAuth3';
export * from './Icon60YearsLogo';
export * from './IconAlert';
export * from './IconAlertCircle';
export * from './IconAngle';
export * from './IconAppStore';
export * from './IconArrowBig';
export * from './IconArrowDown';
export * from './IconArrowLong';
export * from './IconArrowRight';
export * from './IconBestValue';
export * from './IconBin';
export * from './IconBullionLogo';
export * from './IconCalculator';
export * from './IconCalendar';
export * from './IconCart';
export * from './IconCartRepeat';
export * from './IconCase';
export * from './IconChatWithText';
export * from './IconCheck';
export * from './IconCircle';
export * from './IconCircleArrow';
export * from './IconCircleCross';
export * from './IconCirclePlus';
export * from './IconClock';
export * from './IconClockWithArrow';
export * from './IconCoinFocus';
export * from './IconContact';
export * from './IconCopy';
export * from './IconCountry';
export * from './IconCross';
export * from './IconCurrency';
export * from './IconDashed';
export * from './IconDeals';
export * from './IconDeliver';
export * from './IconDeliveryVehicle';
export * from './IconDiscount';
export * from './IconDocument';
export * from './IconDownloadTray';
export * from './IconDrawer';
export * from './IconEdit';
export * from './IconEye';
export * from './IconEyeClosed';
export * from './IconFilters';
export * from './IconFlexibleChoice';
export * from './IconGaLogo';
export * from './IconGaLogoAlert';
export * from './IconGaLogoFull';
export * from './IconGALogoWithBackground';
export * from './IconGift';
export * from './IconGooglePlay';
export * from './IconGraph';
export * from './IconHeaps';
export * from './IconHeart';
export * from './IconHeartBig';
export * from './IconHome';
export * from './IconIncluded';
export * from './IconInfo';
export * from './IconIpCheck';
export * from './IconLBMALogo';
export * from './IconLivePrice';
export * from './IconLock';
export * from './IconMarketGraph';
export * from './IconMazarsLogo';
export * from './IconMinus';
export * from './IconPause';
export * from './IconPaymentPending';
export * from './IconPhone';
export * from './IconPhone2';
export * from './IconPlay';
export * from './IconPlayCircled';
export * from './IconPlus';
export * from './IconQRCode';
export * from './IconReceive';
export * from './IconRedeemProducts';
export * from './IconSearch';
export * from './IconSecureLogo';
export * from './IconSell';
export * from './IconShield';
export * from './IconSmartphoneText';
export * from './IconSmartphoneValid';
export * from './IconSolid';
export * from './IconSpinner';
export * from './IconStar';
export * from './IconSuccess';
export * from './IconSuccessFull';
export * from './IconSwissFlag';
export * from './IconSwissLogo';
export * from './IconSwissServers';
export * from './IconTagCross';
export * from './IconThumbUp';
export * from './IconTransfer';
export * from './IconTrustpilotLogo';
export * from './IconTwoSteps';
export * from './IconUnion';
export * from './IconUser';
export * from './IconZeroPercent';
export * from './payment/IconBankTransfer';
export * from './payment/IconMastercard';
export * from './payment/IconVisa';
export * from './social/IconEmail';
export * from './social/IconFacebook';
export * from './social/IconInstagram';
export * from './social/IconLinkedIn';
export * from './social/IconLinkedInSquare';
export * from './social/IconTwitter';
export * from './social/IconWhatsApp';
export * from './social/IconYoutube';
export * from './SVG';
